import { getSearchInteractionsForRoom } from './search-room-interactions-tracker';

const storageManager = App.es6.shared.storage_manager().init('local');

export const STORAGE_KEYS = {
  NAVIGATION: {
    EXTERNAL_NAVIGATION_TRACKER_v1: 'EXTERNAL_NAVIGATION_TRACKER_v1',
    VENUE_PAGE_TRACKER_v1: 'VENUE_PAGE_TRACKER_v1',
    GOOGLE_NAVIGATION_TRACKER_v1: 'GOOGLE_NAVIGATION_TRACKER_v1',
    MAIL_NAVIGATION_TRACKER_v1: 'MAIL_NAVIGATION_TRACKER_v1',
  },
  LOCATION_PAGE: 'LOCATION_PAGE_TRACKER_v1',
  VENUE_PAGE: 'VENUE_PAGE_TRACKER_v1',
  SIMILAR_ROOM: 'SIMILAR_ROOMS_TRACKER_v1',
  RECOMMENDER_ROOM: 'RECOMMENDER_TRACKER_v1',
  SEARCH: 'SEARCH_TRACKER_v1',
};

const SESSION_WINDOW_WEEKS = 4;

function getToday() {
  const date = new Date();

  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
}

const today = getToday();

export function clearOldInteractionsEntries(key) {
  const storage = storageManager.get(key) ?? '{}';
  const data = JSON.parse(storage);

  Object.keys(data).forEach((date) => {
    if (window.dayjs(date).isBefore(window.dayjs().subtract(SESSION_WINDOW_WEEKS, 'week'))) {
      delete data[date];
      console.log('cleared old entry', date);
    }
  });

  storageManager.set(key, JSON.stringify(data));
}

export function universalTrackRoomClicked(key, roomId) {
  if (!roomId) {
    throw new Error(`roomId is required, got: ${roomId}`);
  }

  const storage = storageManager.get(key) ?? '{}';
  const data = JSON.parse(storage);

  data[today] = data[today] ?? { clicked: [] };

  data[today].clicked.push(roomId);
  storageManager.set(key, JSON.stringify(data));
}

export function universalGetClicksForRoom(key, roomId) {
  let data = null;
  try {
    const storage = storageManager.get(key) ?? '{}';
    data = JSON.parse(storage);

    let wasClicked = false;

    Object.values(data).forEach(({ clicked }) => {
      if (clicked.includes(roomId)) {
        wasClicked = true;
      }
    });

    return {
      wasClicked,
    };
  } catch (err) {
    console.log(data);
    console.error('Failed getting recommender clicks', err);
    Rollbar.error('Failed getting recommender clicks', err);
    return {
      wasClicked: false,
    };
  }
}

export function getAllInteractionsPropertiesForEnquiry(roomId) {
  const searchStats = getSearchInteractionsForRoom(STORAGE_KEYS.SEARCH, roomId);
  const recommenderStats = universalGetClicksForRoom(STORAGE_KEYS.RECOMMENDER_ROOM, roomId);
  const locationPageStats = universalGetClicksForRoom(STORAGE_KEYS.LOCATION_PAGE, roomId);
  const venuePageStats = universalGetClicksForRoom(STORAGE_KEYS.VENUE_PAGE, roomId);
  const externalNavigation = universalGetClicksForRoom(STORAGE_KEYS.NAVIGATION.EXTERNAL_NAVIGATION_TRACKER_v1, roomId);
  const googleNavigation = universalGetClicksForRoom(STORAGE_KEYS.NAVIGATION.GOOGLE_NAVIGATION_TRACKER_v1, roomId);
  const mailNavigation = universalGetClicksForRoom(STORAGE_KEYS.NAVIGATION.MAIL_NAVIGATION_TRACKER_v1, roomId);
  const similarRooms = universalGetClicksForRoom(STORAGE_KEYS.SIMILAR_ROOM, roomId);

  return {
    seenOnSearch: searchStats.wasSeen,
    clickedOnSearch: searchStats.wasClicked,
    clickedOnRecommender: recommenderStats.wasClicked,
    clickedOnLocationPage: locationPageStats.wasClicked,
    clickedOnVenuePage: venuePageStats.wasClicked,
    clickedOnSimilarRooms: similarRooms.wasClicked,
    externalNavigation: externalNavigation.wasClicked,
    googleNavigation: googleNavigation.wasClicked,
    mailNavigation: mailNavigation.wasClicked,
  };
}
